import { Component, OnInit, ViewChild } from '@angular/core';
import ClientFormComponent from 'app/components/client-form/client-form.component';
import { Entity } from 'app/pages/product/product.model';
import { SystemService } from 'app/services/system.service';
import {EntityListComponent} from '../../../components/entity-list/entity-list.component';
import {Team} from '../../../components/team-form/team.model';
import {Client} from '../../../components/client-form/client.model';

@Component({
  selector: 'app-client-page',
  templateUrl: './client-page.component.html',
  styleUrls: ['./client-page.component.scss']
})
export class ClientPageComponent implements OnInit {

    clients: Entity[];
    client: any;

    @ViewChild('clientForm')
    clientForm: ClientFormComponent;

    @ViewChild('entityList')
    entityList: EntityListComponent;

    listTitle: string;

    constructor(public _systemService: SystemService) {
        
    }

    selected(entity): void{
        this.client = entity;
        this.clientForm.selected(entity);
    }

    ngOnInit(): void {
        this.clients = this._systemService.clients;
    }

    entityChanged(entity: any): void{
        //if entity is a number, it means that the entity was deleted
        if (typeof entity === 'number') {
            const activityIndex = this.clients.findIndex(elem => elem.id === entity);
            this.clients.splice(activityIndex, 1);
            this.selected(null);
        }else {
            const activityIndex = this.clients.findIndex(elem => elem.id === entity.id);
            this.clients.splice(activityIndex, 1);
            if (entity) {
                this.client = entity;
                this.clients.push(entity);
                this.clients.sort((a, b) => a.name > b.name ? 1 : -1);
                this.selected(this.client);
            } else {
                this.selected(null);
            }
        }
    }

    newClient(): void{
        this.client = new Client();
        if (this.entityList) {
            this.entityList.deselectAll();
        }
        this.selected(this.client);
    }

}
